module.exports = __webpack_public_path__ + "media/images/award-d591e113.png";